import { createActions } from 'redux-actions';
import { batch } from 'react-redux';

import { selectWorkflowActiveStepLinkByRel } from '../../../selectors';
import registrationApi from '../../../api/registrationApi';
import { showMainLoading, hideMainLoading } from '../main/actions';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

let resendBanklinkSmsTimerId;

export const { updateSendSmsForBankConfirmation, updateCanResendSmsForBanklink } = createActions(
  actionTypes.UPDATE_SEND_SMS_FOR_BANK_CONFIRMATION,
  actionTypes.UPDATE_CAN_RESEND_SMS_FOR_BANKLINK,
  getActionOptions(ACTION_PREFIX),
);

export const clearTimer = () => {
  if (resendBanklinkSmsTimerId > -1) {
    clearTimeout(resendBanklinkSmsTimerId);
    resendBanklinkSmsTimerId = -1;
  }
};

export const sendBanklinkSms = () => {
  clearTimer();

  return (dispatch, getState) => {
    resendBanklinkSmsTimerId = setTimeout(
      () => dispatch(updateCanResendSmsForBanklink(true)),
      60000,
    );

    batch(() => {
      dispatch(showMainLoading('Sending SMS for bank connection...'));
      dispatch(
        updateSendSmsForBankConfirmation({
          isSubmitted: false,
          isError: false,
          message: null,
          isRequesting: true,
        }),
      );
      dispatch(updateCanResendSmsForBanklink(false));
    });

    const state = getState();
    const stepLink =
      selectWorkflowActiveStepLinkByRel(state, 'BankLink') ||
      selectWorkflowActiveStepLinkByRel(state, 'BankLink/Pending');

    registrationApi
      .sendBanklinkSms(stepLink.href)
      .then((response) => {
        if (response) {
          dispatch(
            updateSendSmsForBankConfirmation({
              isSubmitted: true,
              isError: false,
              message: 'SMS for bank connection sent successfully.',
              isRequesting: false,
            }),
          );
        } else {
          batch(() => {
            dispatch(
              updateSendSmsForBankConfirmation({
                isSubmitted: true,
                isError: true,
                message: "Looks like we're having some trouble, please try again later.",
                isRequesting: false,
              }),
            );
            dispatch(updateCanResendSmsForBanklink(true));
          });
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((_reason) => {
        batch(() => {
          dispatch(
            updateSendSmsForBankConfirmation({
              isSubmitted: true,
              isSmsSentFailed: true,
              message: "Looks like we're having some trouble, please try again later.",
              isRequesting: false,
              isError: true,
            }),
          );
          dispatch(updateCanResendSmsForBanklink(true));
        });
      })
      .finally(() => dispatch(hideMainLoading()));
  };
};
